import script from "./BuyTreca.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyTreca.vue?vue&type=script&setup=true&lang=js"

import "./BuyTreca.vue?vue&type=style&index=0&id=97b6432a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97b6432a"]])

export default __exports__